
module.exports = function getResource(label, vars = []) {
    let resources = {
        selectDay: 'Veuillez sélectionner un jour',
        prev: 'Précédent',
        next: 'Suivant'
    };
    return resources[label];
};
